<script>
import $ from 'jquery'
import setting from '@/setting.js'
import common from '@/common.js'
import API from '@/api.js'
import Calculate from '@/calculate.js'
import Seasonpicker from '@/components/utility/Seasonpicker'
import {mapGetters} from "vuex"

export default {
    name: 'ThreeSearch',
    mixins: [Seasonpicker],
    props: ['initMode', 'mode', 'atBatBalls', 'allBalls', 'playing', 'nowID', 'colors', 'savedBalls', 'enableMultiPos', 'baseBallIndex', 'getBallText', 'searchModalFlg', 'currentSavedBallsId', 'searchModalType', 'savedStandardBall', 'currentSavedStandardBallId'],
    emits: ['get-saved-standard-balls', 'update-all', 'close-search-modal', 'get-saved-balls', 'loading-off', 'loading-on'],
    data() {
        return {
            year: this.$moment().year(),
            setting,
            userAccountPitcherID: null,             // ユーザーアカウントに登録された選手ID
            userAccountPositionPitcher: false,      // ユーザーアカウントに登録された選手IDが投手か
            userAccountPermission3dMyTeam: true,    // 自チームの他投手データ閲覧権限
            userAccountPermission3dOtherTeam: true,   // 他チームの投手データ閲覧権限
            searchState: 0,
            /* 検索条件v-model */
            formSelectTeam: setting.pulldownTeamList[0],
            formSelectPlayer: '',
            formSelectBall: '',
            formSelectDate: ['', ''],
            formSelectStadium: '',
            formSelectType: 0,
            /* 検索結果フィルター */
            filterSelectDate: '',
            filterSelectHittype: '',
            filterSelectResult: '',
            filterSelectVsTeam: '',
            filterSelectVsBatter: '',
            filterSelectAtBat: '',
            /* */
            formDategameSchedule: {},
            savedBasllsId: [],
            savedStandardBasllsId: [],
            minDate: '2015-05-01',
            maxDate: window.moment(new Date()).format('YYYY-MM-DD'),
            isValidateList: {
                player: false,
                date: false
            },
            isValidate: true,
            formTeamList: null,
            listOfTeams: {},
            sortedListOfTeams: [],  // プルダウン用
            listOfRosters: {},
            sortedListOfStadiums: [],
            // pitchingDateList: [],
            // pitchingResultList: {},
            pitchingDefaultResultList: {},
            // pitchingVsBatterList: {},
            temp_kinds: [
                'ストレート',
                'カーブ',
                'ストレート',
                'スライダー',
                'チェンジアップ'
            ],
            opened: true,
            priority: [
                'Fastball',
                'ChangeUp',
                'Curveball',
                'Cutter',
                'KnuckleBall',
                'Sinker',
                'Slider',
                'Splitter'
            ],
            sortedArray: {
                'Fastball': [],
                'ChangeUp': [],
                'Curveball': [],
                'Cutter': [],
                'KnuckleBall': [],
                'Sinker': [],
                'Slider': [],
                'Splitter': []
            },
            pitchTypeName: {
                'Fastball': '速球',
                'ChangeUp': 'チェンジアップ',
                'Curveball': 'カーブ',
                'Cutter': 'カットボール',
                'KnuckleBall': 'ナックル',
                'Sinker': 'シンカー',
                'Slider': 'スライダー',
                'Splitter': 'スプリッター'
            },
            typesOf3DSearchKorBB: {
                'Strikeout': {
                    name: '三振'
                },
                'StrikeoutSwinging': {
                    name: '三振（空振り）'
                },
                'StrikeoutCalled': {
                    name: '三振（見逃し）'
                },
                'Walk': {
                    name: '四球'
                }
            },
            typesOf3DSearchPitchCall: {
                'StrikeSwinging': {
                    name: '空振ストライク'
                },
                'StrikeSwingingZone': {
                    name: '空振ストライク（ゾーン内）'
                },
                'StrikeSwingingO-Zone': {
                    name: '空振ストライク（ゾーン外）'
                },
                'StrikeCalled': {
                    name: '見逃しストライク'
                },
                'FoulBall': {
                    name: 'ファール'
                },
                'BallCalled': {
                    name: 'ボール'
                },
                'BallCalledHitByPitch': {
                    name: 'デッドボール'
                }
            },
            filterInPlayList: [
                'Sacrifice',
                'FieldersChoice',
                'Single',
                'Double',
                'Triple',
                'HomeRun',
                'Out',
                'Error',
                'FoulBall'
            ],
            filterIndexArray: [],
            filteredDataArray: [],
            defaultBalls: [],
            sortMode: 0,
            filterListFlg: false,
            mostFastBall: {},
            ballsOfCompare: [],
            // compare sort
            compareSortNumber: 0,
            compareSortList: [
                'pitchno',
                'RelSpeed',
                'RelSpeed_Per',
                'SpinRate',
                'Rifle',
                'w_sin_a',
                'InducedVertBreak',
                'HorzBreak',
                'RelHeight',
                'RelSide'
            ],
            // 0 昇順 1 降順
            compareSortListStatus: 0,
            // 検索結果球数
            allBallNumber: 0,
            playerTeam: '',
            globalNPBRosters: {},
            listOfTeamsLS: this.$copy(this.$store.getters.listOfTeams)
        }
    },
    computed: {
        ...mapGetters(['listOfStadiums','userAccount']),
        // 検索のチーム名が選択可能か
        formSelectTeamSelectable () {
            if (this.sortedListOfTeams === undefined) {
                return false
            }
            return this.sortedListOfTeams.length === 1
        },
        // 検索の投手名が選択可能か
        formSelectPlayerSelectable () {
            if (this.listOfRosters[this.formSelectTeam] === undefined) {
                return false
            }
            return Object.keys(this.listOfRosters[this.formSelectTeam]).length === 1
        },
        currentBallNumber() {
            return this.filteredBalls.length
        },
        // 検索結果の全球を元に、フィルターで条件を絞り込む
        filteredBalls () {
            if (this.defaultBalls.length === 0) {
                return []
            }
            let tempBalls = []
            // 試合
            if (this.formSelectType === 0) {
                this.defaultBalls.forEach((d) => {
                    let count = 0
                    if (this.filterSelectDate === '' || this.filterSelectDate === d.data['Date']) {
                        count++
                    }
                    if (this.formSelectBall === '' || this.formSelectBall === d.data['AlphaTaggedPitchType']) {
                        count++
                    }
                    if (this.filterSelectHittype === '' || this.filterSelectHittype === d.data['HitType'].id) {
                        count++
                    }
                    // 結果が空ならカウント
                    if (this.filterSelectResult === '') {
                        count++
                        // 結果がボールなら、データがボール、デッドボールもしくは四球ならカウント
                    } else if (this.filterSelectResult === 'BallCalled') {
                        if (d.data.result.id === 'BallCalled' || d.data.result.id === 'BallCalledHitByPitch' || d.data.result.id === 'Walk') {
                            count++
                        }
                        // 結果がStrikeSwingingなら、データがStrikeSwinging、StrikeSwingingZone、もしくはStrikeSwingingO-Zoneならカウント
                    } else if (this.filterSelectResult === 'StrikeSwinging') {
                        if (d.data.result.id === 'StrikeSwingingZone' || d.data.result.id === 'StrikeSwingingO-Zone') {
                            count++
                        }
                        // 結果がStrikeoutなら、データがStrikeout、StrikeoutSwinging、もしくはStrikeoutCalledならカウント
                    } else if (this.filterSelectResult === 'Strikeout') {
                        if (d.data.result.id === 'Strikeout' || d.data.result.id === 'StrikeoutSwinging' || d.data.result.id === 'StrikeoutCalled') {
                            count++
                        }
                        // 結果がボール、空振りストライク以外なら、データと等しければカウント
                    } else {
                        if (this.filterSelectResult === d.data.result.id) {
                            count++
                        }
                    }
                    if (this.filterSelectVsTeam === '' || this.filterSelectVsTeam === d.data['BatterTeamId']) {
                        count++
                    }
                    if (this.filterSelectVsBatter === '' || this.filterSelectVsBatter === d.data['BatterId']) {
                        count++
                    }
                    if (this.filterSelectAtBat === '' || this.filterSelectAtBat === d.data['AtBat']) {
                        count++
                    }
                    if (count === 7) {
                        tempBalls.push(d)
                    }
                })
                // ブルペン
            } else if (this.formSelectType === 1) {
                this.defaultBalls.forEach((d) => {
                    if (this.formSelectBall === '' || this.formSelectBall === d.data['AlphaTaggedPitchType']) {
                        tempBalls.push(d)
                    }
                })
                if (this.compareSortListStatus === 0) {
                    tempBalls.sortBy('pitchno')
                } else {
                    tempBalls.sortBy('pitchno', true)
                }
                if (this.compareSortListStatus === 0) {
                    tempBalls.sort((a, b) => {
                        if (a.data[this.compareSortList[this.compareSortNumber]] < b.data[this.compareSortList[this.compareSortNumber]]) return -1
                        if (a.data[this.compareSortList[this.compareSortNumber]] > b.data[this.compareSortList[this.compareSortNumber]]) return 1
                        return 0
                    })
                } else {
                    tempBalls.sort((a, b) => {
                        if (a.data[this.compareSortList[this.compareSortNumber]] > b.data[this.compareSortList[this.compareSortNumber]]) return -1
                        if (a.data[this.compareSortList[this.compareSortNumber]] < b.data[this.compareSortList[this.compareSortNumber]]) return 1
                        return 0
                    })
                }
            }
            return tempBalls
        },
        // フィルタープルダウン項目 試合日
        pitchingDateList () {
            if (this.defaultBalls.length === 0) return []
            let tempList = []
            let tempBalls = this.getTempBalls('Date')
            tempBalls.forEach((d) => {
                if (tempList.indexOf(d.data['Date']) === -1) {
                    tempList.push(d.data['Date'])
                }
            })
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach((d) => {
                    if (d.id === 'Date') {
                        tempList.push(this.filterSelectDate)
                    }
                })
            }
            return tempList
        },
        // フィルタープルダウン項目 球種
        pitchingTypeList () {
            if (this.defaultBalls.length === 0) return []
            let tempList = []
            let tempList2 = []
            let tempBalls = this.getTempBalls('AlphaTaggedPitchType')
            tempBalls.forEach((d) => {
                if (tempList.indexOf(d.data['AlphaTaggedPitchType']) === -1) {
                    tempList.push(d.data['AlphaTaggedPitchType'])
                }
            })
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach((d) => {
                    if (d.id === 'AlphaTaggedPitchType') {
                        tempList.push(this.formSelectBall)
                    }
                })
            }
            // 指定順に並び替え
            this.setting.listOfLegend.forEach((d) => {
                tempList.forEach((d2) => {
                    if (d === d2) {
                        tempList2.push(d)
                    }
                })
            })
            return tempList2
        },
        // フィルタープルダウン項目 打球
        pitchingHitTypeList () {
            if (this.defaultBalls.length === 0) return []
            let tempList = []
            let tempList2 = []
            let tempBalls = this.getTempBalls('HitType')
            if (this.filterSelectResult === '' || this.filterInPlayList.indexOf(this.filterSelectResult) > -1) {
                // 判定結果が空なら全てを表示
                tempBalls.forEach(function (d) {
                    if (tempList.indexOf(d.data['HitType'].id) === -1) {
                        tempList.push(d.data['HitType'].id)
                    }
                })
            } else {
                // 判定結果が三振等InPlayでなければ空にする
                return []
            }
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach((d) => {
                    if (d.id === 'HitType') {
                        tempList.push(this.filterSelectHittype)
                    }
                })
            }
            this.setting.listOfHitType.forEach((d) => {
                tempList.forEach((d2) => {
                    if (d === d2) {
                        tempList2.push(d)
                    }
                })
            })
            return tempList2
        },
        // フィルタープルダウン項目 打者結果
        pitchingResultList () {
            if (this.defaultBalls.length === 0) return []
            let tempList = []
            let tempList2 = []
            let tempBalls = this.getTempBalls('result')
            if (this.filterSelectHittype === '') {
                // 打球のセレクタが空（未設定）であれば全てを追加
                tempBalls.forEach(function (d) {
                    if (tempList.indexOf(d.data.result.id) === -1) {
                        tempList.push(d.data.result.id)
                    }
                })
            } else {
                // 打球に値があれば三振などを除外
                tempBalls.forEach((d) => {
                    if (this.filterInPlayList.indexOf(d.data.result.id) > -1 && tempList.indexOf(d.data.result.id) === -1) {
                        tempList.push(d.data.result.id)
                    }
                })
            }
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach((d) => {
                    if (d.id === 'result') {
                        tempList.push(this.filterSelectResult)
                    }
                })
            }
            // 空振り（ゾーン外、ゾーン内）があれば空振りを追加
            if (tempList.indexOf('StrikeSwingingZone') > -1 || tempList.indexOf('StrikeSwingingO-Zone') > -1) {
                tempList.push('StrikeSwinging')
            }
            // 三振（空振り、見逃し）があれば三振を追加
            if (tempList.indexOf('StrikeoutSwinging') > -1 || tempList.indexOf('StrikeoutCalled') > -1) {
                tempList.push('Strikeout')
            }
            Object.keys(this.pitchingDefaultResultList).forEach(function (d) {
                tempList.forEach(function (d2) {
                    if (d === d2) {
                        tempList2.push(d)
                    }
                })
            })
            return tempList2
        },
        // フィルタープルダウン項目 対戦チーム
        pitchingVsTeamList () {
            if (this.defaultBalls.length === 0) return []
            let tempList = []
            let tempList2 = []
            let tempBalls = this.getTempBalls('BatterTeamId')
            tempBalls.forEach(function (d) {
                if (tempList.indexOf(d.data['BatterTeamId']) === -1) {
                    tempList.push(d.data['BatterTeamId'])
                }
            })
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach(function (d) {
                    if (d.id === 'BatterTeamId') {
                        tempList.push(this.filterSelectVsTeam)
                    }
                }.bind(this))
            }
            this.setting.pulldownTeamList.forEach(function (d) {
                tempList.forEach(function (d2) {
                    if (d === d2) {
                        tempList2.push(d)
                    }
                })
            })
            // NPB12球団以外があれば追加
            tempList.forEach(function (d2) {
                if (this.setting.pulldownTeamList.indexOf(d2) === -1) {
                    tempList2.push(d2)
                }
            }.bind(this))
            return tempList2
        },
        // フィルタープルダウン項目 打者
        pitchingVsBatterList () {
            if (this.defaultBalls.length === 0 || this.filterSelectVsTeam === '') {
                return []
            }
            let tempList = []
            let tempList2 = []
            let tempBalls = this.getTempBalls('BatterId')
            tempBalls.forEach((d) => {
                if (tempList.indexOf(d.data['BatterId']) === -1 && this.filterSelectVsTeam === d.data['BatterTeamId']) {
                    tempList.push(d.data['BatterId'])
                    let tempObj = {
                        id: d.data['BatterId'],
                        name: d.data['BatterName']
                    }
                    tempList2.push(tempObj)
                }
            })
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach((d) => {
                    if (d.id === 'BatterId') {
                        tempList.push(this.filterSelectVsBatter)
                    }
                })
            }
            return tempList2
        },
        // フィルタープルダウン項目 打席
        pitchingVsAtBatList () {
            if (this.defaultBalls.length === 0) return []
            let tempList = []
            let tempBalls = this.getTempBalls('AtBat')
            tempBalls.forEach(function (d) {
                if (tempList.indexOf(d.data['AtBat']) === -1) {
                    tempList.push(d.data['AtBat'])
                }
            })
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.length > 0) {
                let index = -1
                this.filterIndexArray.forEach(function (d) {
                    if (d.id === 'AtBat') {
                        tempList.push(this.filterSelectAtBat)
                    }
                }.bind(this))
            }
            tempList.sort(function (a, b) {
                if (a === '-') return -1
                if (a < b) return -1
                if (a > b) return 1
                return 0
            })
            return tempList
        },
        filteredRoster() {
            let rosters = []
            if (this.formSelectTeam && this.year)
                for (let key in this.listOfRosters[this.formSelectTeam]) {
                    let p = this.listOfRosters[this.formSelectTeam][key]
                    if (this.existsPlayer(this.year, this.formSelectTeam, p)) {
                        rosters.push(p)
                    }
                }
            return rosters
        }
    },
    watch: {
        pitchingVsBatterList(v) {
            if (v.length === 0) {
                this.filterSelectVsBatter = ''
            }
        },
        // 条件設定
        formSelectTeam (val) {
            // 選択されたチームをdatepickerに送る
            this.playerTeam = val

            if (val === this.userAccount.my_team) {
                if (this.userAccountPositionPitcher) {
                    // 自チームが指定され、かつピッチャーであれば自身をデフォルト表示
                    this.formSelectPlayer = this.userAccountPitcherID
                    this.checkSelectPlayer()
                } else {
                    // 自チームが設定しなおされたらクリア
                    this.formSelectPlayer = ''
                    this.formSelectDate = ['', '']
                }
            } else {
                // 他チームが設定されたらクリア
                this.formSelectPlayer = ''
                this.formSelectDate = ['', '']
            }
        },
        formSelectPlayer (val) {
            if (this.formSelectTeam && val) {
                // チームと選手両方が設定されていれば、その選手の登板試合を取得
                this.getGameList()
            } else if (!val) {
                this.formSelectDate = ['', '']
            }
        },
        formSelectDate: 'checkSelectDate',
        // 検索結果
        filterSelectVsTeam () {
            this.filterSelectVsBatter = ''
            this.setFilterIndexArray('BatterTeamId', this.filterSelectVsTeam)
        },
        filterSelectDate () {
            this.setFilterIndexArray('Date', this.filterSelectDate)
        },
        formSelectBall () {
            this.setFilterIndexArray('AlphaTaggedPitchType', this.formSelectBall)
        },
        filterSelectHittype () {
            this.setFilterIndexArray('HitType', this.filterSelectHittype)
        },
        filterSelectResult () {
            this.setFilterIndexArray('result', this.filterSelectResult)
        },
        filterSelectVsBatter () {
            this.setFilterIndexArray('BatterId', this.filterSelectVsBatter)
        },
        filterSelectAtBat () {
            this.setFilterIndexArray('AtBat', this.filterSelectAtBat)
        }
    },
    mounted() {
        // 表示可能範囲の確認
        // 選手ID等の登録があるか
        if (this.userAccount.additional !== null) {
            // 紐付けられた選手ID
            if (this.userAccount.additional.player_id !== undefined && this.userAccount.additional.player_id !== '') {
                this.userAccountPitcherID = this.userAccount.additional.player_id
            }
            // 紐付けられた選手IDがある場合、それが投手かどうかを判定
            if (this.userAccountPitcherID !== null) {
                let position = this.$p.get(this.userAccount.additional.my_team)[this.userAccountPitcherID].position
                if (this.userAccountPitcherID !== null && ['pitcher','投手'].includes(position)) {
                    this.userAccountPositionPitcher = true
                }
            }
            // 自チームほか投手の投球データの閲覧権限（0は不可）
            if (this.userAccount.additional.permission_3d_my_team === '0') {
                this.userAccountPermission3dMyTeam = false
            }
            // 他チーム投手の投球データの閲覧権限（0は不可）
            if (this.userAccount.additional.permission_3d_other_team === '0') {
                this.userAccountPermission3dOtherTeam = false
            }
        }
        // 打者結果のデフォルトリストを作成
        Object.keys(setting.typesOfPlayResult).forEach((d) => {
            this.pitchingDefaultResultList[d] = setting.typesOfPlayResult[d]
        })
        Object.keys(this.typesOf3DSearchKorBB).forEach((d) => {
            this.pitchingDefaultResultList[d] = this.typesOf3DSearchKorBB[d]
        })
        Object.keys(this.typesOf3DSearchPitchCall).forEach((d) => {
            this.pitchingDefaultResultList[d] = this.typesOf3DSearchPitchCall[d]
        })
        this.getTeamList()
        $('.searchWrapper.result').on('touchstart', (event) => {
            if (event.touches.length > 1) {
                event.preventDefault()
            }
        })
    },
    methods: {
        invalidPinch (e) {
            e.preventDefault()
        },
        closeSearchModal () {
            this.$emit('close-search-modal')
        },
        loadingOn (message) {
            this.$emit('loading-on', message)
        },
        loadingOff () {
            this.$emit('loading-off')
        },
        messageModalOn (msg) {
            this.$root.$emit('messageModalOn', msg)
        },
        noSelectedPlayer () {
            this.$root.$emit('messageModalOn', '投手を選択してください')
        },
        // ブルペン検索結果のソート
        changeCompareSortNumber (num) {
            if (this.compareSortNumber === num) {
                this.compareSortListStatus = (this.compareSortListStatus === 0) ? 1 : 0
            } else {
                this.compareSortListStatus = 0
            }
            this.compareSortNumber = num
        },
        // 検索画面のチームプルダウン用一覧を生成
        getTeamList () {
            this.sortedListOfTeams = []
            setting.pulldownTeamList.forEach((d) => {
                this.listOfTeams[d] = this.listOfTeamsLS[d]
                // すでにglobalNPBRostersに保存されていればスルー
                if (!(d in this.globalNPBRosters)) {
                    this.getRosterList(d)
                } else {
                    this.$set(this.listOfRosters, d, this.globalNPBRosters[d])
                }
            })
            // プルダウン用に並び替え
            if (this.userAccountPermission3dOtherTeam) {
                // 他チームの参照権限がある
                this.setting.pulldownTeamList.forEach((list) => {
                    Object.keys(this.listOfTeams).forEach((list2) => {
                        if (list === list2) {
                            let obj = this.$copy(this.listOfTeams[list2])
                            obj.teamID = list2
                            this.sortedListOfTeams.push(obj)
                        }
                    })
                })
                this.formSelectTeam = this.userAccount.my_team
            } else {
                // 他チームの参照権限がない
                let obj = this.$copy(this.listOfTeams[this.userAccount.my_team])
                obj.teamID = this.userAccount.my_team
                this.sortedListOfTeams.push(obj)
                this.formSelectTeam = this.userAccount.my_team
            }
        },
        // フィルターの条件が変わったらプルダウン用のデータを作成する
        setFilterIndexArray (id, val) {
            // console.log('setFilterIndexArray', id, val)
            let filterIndexArrayIndex = -1
            this.filterIndexArray.forEach((obj, i) => {
                if (obj.id === id) {
                    filterIndexArrayIndex = i
                }
            })
            if (filterIndexArrayIndex === -1) {
                // フィルターとして登録されていなければ追加
                let obj = {
                    id: id,
                    val: val
                }
                this.filterIndexArray.push(obj)
            } else {
                // すでに登録されている場合
                if (val === '') {
                    this.filterIndexArray.splice(filterIndexArrayIndex, 1)
                } else {
                    this.filterIndexArray[filterIndexArrayIndex] = {
                        id: id,
                        val: val
                    }
                }
            }
            this.filteredDataArray = []
            // filterIndexArrayに登録された条件の数だけデータの配列を作る
            this.filterIndexArray.forEach((d, index) => {
                this.filteredDataArray.push([])
                let tempBalls = []
                if (index === 0) {
                    // 0番目なら全データ
                    tempBalls = [].concat(this.defaultBalls)
                } else {
                    // 1番目以降なら直前のデータを使う
                    tempBalls = [].concat(this.filteredDataArray[(index - 1)])
                }
                // filterIndexArrayのindex番目に追加した項目で絞り込まれたデータがfilteredDataArrayのindex番目に配列として追加されていく
                tempBalls.forEach((d2) => {
                    // console.log(d.id , d2['data'][d.id], d.val)
                    if (d.id === 'result' || d.id === 'HitType') {
                        if (d2['data'][d.id].id === d.val) {
                            this.filteredDataArray[index].push(d2)
                        }
                    } else {
                        if (d2['data'][d.id] === d.val) {
                            this.filteredDataArray[index].push(d2)
                        }
                    }
                })
            })
        },
        // プルダウン用にフィルタリングされた球の配列を返す
        getTempBalls (keyStr) {
            let index = -1
            let tempBalls
            this.filterIndexArray.forEach((d, filterIndexArrayIndex) => {
                // filterIndexArrayに追加されている項目かチェック
                if (d.id === keyStr) {
                    index = filterIndexArrayIndex
                }
            })
            if (index === -1) {
                // filterIndexArrayにない
                if (this.filterIndexArray.length > 0) {
                    // filterIndexArrayが空でなければfilteredDataArrayの最後の配列を渡す
                    tempBalls = [].concat(this.filteredDataArray[(this.filteredDataArray.length - 1)])
                } else {
                    // 空なら全データを渡す
                    tempBalls = [].concat(this.defaultBalls)
                }
            } else if (index === 0) {
                // 1番目に追加された項目なら全データを渡す
                tempBalls = [].concat(this.defaultBalls)
            } else {
                // 上記以外なら該当する項目の一つ前の配列を渡す
                tempBalls = [].concat(this.filteredDataArray[(index - 1)])
            }
            return tempBalls
        },
        // 選択可能なチームの出場投手プルダウン用一覧を生成
        getRosterList (teamID) {
            const globalNPBAllPlayers = this.$p.get(teamID)
            // console.log('getRosterList', teamID, this.userAccount.my_team, this.userAccountPermission3dMyTeam)
            if (teamID === this.userAccount.my_team && !this.userAccountPermission3dMyTeam) {
                // 自チームが指定されており、かつ自チーム他の閲覧権限がない
                this.$set(this.listOfRosters, teamID, {})
                if (this.userAccountPositionPitcher) {
                    // ピッチャーであれば自分のみ表示する
                    this.$set(this.listOfRosters[teamID], this.userAccountPitcherID, globalNPBAllPlayers[this.userAccountPitcherID])
                    this.formSelectPlayer = this.userAccountPitcherID
                    this.checkSelectPlayer()
                }
            } else {
                // teamIDが自チームでない、もしくは自チームの他投手のデータ閲覧権限がある
                let query = {
                    team_id: teamID,
                    pitching: 1
                }
                API.GAMES.ROSTERS.SUMMARY.getIndex(query,
                    (json) => {
                        this.$set(this.listOfRosters, teamID, {})
                        this.$set(this.globalNPBRosters, teamID, {})
                        // 登板データあり投手が取得できたら、情報を肉付けする
                        json.forEach((d) => {
                            let uid = d.player.split('@')[0]
                            this.$set(this.listOfRosters[teamID], uid, globalNPBAllPlayers[uid])
                            // globalNPBRostersにキャッシュ保存しておく
                            this.$set(this.globalNPBRosters[teamID], uid, globalNPBAllPlayers[uid])
                            // 選手にadditionalがない、もしくはユニフォーム設定がない場合はハイフン表示にする。
                            if (this.globalNPBRosters[teamID][uid].additional === null) {
                                this.$set(this.globalNPBRosters[teamID][uid], 'additional',  {
                                    uniform_number: '-'
                                })
                            } else if (this.globalNPBRosters[teamID][uid].additional.uniform_number === undefined) {
                                this.$set(this.globalNPBRosters[teamID][uid].additional, 'uniform_number', '-')
                            }
                        })
                    },
                    (error) => {
                        common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getRosterList', JSON.stringify(error))
                    }
                )
            }
        },
        // 選択した投手の登板した試合を取得
        getGameList () {
            //console.log('getGameList')
            let options = {
                pitching: 1,
                'date-before': this.year + '-12-31',
                'date-after': this.year + '-01-01'
            }
            this.sortedListOfStadiums = []
            API.TEAMS.PLAYERS.GAMES.getIndex(this.formSelectTeam, this.formSelectPlayer, options, (json) => {
                // success
                //console.log('getGameList取得成功', json)
                // 取得した試合一覧のフォーマットを整形（年をキーにしたオブジェクト形式に）
                let tmpObj = {}
                json.sortBy('date')
                let minDate = json.first().date
                let maxDate = json.last().date
                for (let i = 0, len = json.length; i < len; i++) {
                    let tmpYear = this.$d(json[i].date).format('YYYY')
                    if (!(tmpYear in tmpObj)) {
                        tmpObj[tmpYear] = []
                    }
                    // 対戦チーム名
                    let vsTeam = ''
                    if (this.formSelectTeam === json[i].awayteam_id) {
                        vsTeam = json[i].hometeam_id
                    } else {
                        vsTeam = json[i].awayteam_id
                    }
                    json[i]['vsTeamID'] = vsTeam
                    json[i]['vsTeam'] = this.listOfTeamsLS[vsTeam].name_short
                    json[i]['vsTeamFull'] = this.listOfTeamsLS[vsTeam].name
                    tmpObj[tmpYear].push(json[i])
                    // スタジアム選択用
                    if (this.sortedListOfStadiums.indexOf(json[i].stadium) < 0) {
                        this.sortedListOfStadiums.push(json[i].stadium)
                    }
                }
                tmpObj['minDate'] = minDate
                tmpObj['maxDate'] = maxDate
                this.formSelectDate = [this.$d(minDate).format('YYYY年MM月DD日'), this.$d(maxDate).format('YYYY年MM月DD日')]
                this.formDategameSchedule = Object.assign({}, tmpObj)
                if (this.formSelectStadium && !this.sortedListOfStadiums.includes(this.formSelectStadium)) {
                    this.formSelectStadium = ''
                }
                /*
                this.tempGameList = Object.assign({}, tmpObj)
                if (pitcherData.condType === 'multi') {
                  this.getPitchesMultiCount(pitcherData)
                } else {
                  this.getGameDetailSingle(pitcherData)
                }
                // 対戦チームの選手情報を取得
                window.setTimeout(function () {
                  this.getVsTeamsPlayersList()
                }.bind(this), 1000)
                */
            }, (error) => {
                // error
                console.log('getGameList取得失敗', error)
                common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getGameList', JSON.stringify(error))
            })
        },
        // 比較球検索（指定した球種の球数）
        getBallCount () {
            // 球種の指定がない場合はそのまま全球数取得
            if (this.formSelectBall === '') {
                this.getBallCountAll(0)
                return false
            }
            // 球種の指定がある場合はその球種の球数を取得
            let query = {
                'date-after': this.$d(this.formSelectDate[0]).format('YYYY-MM-DD'),
                'date-before': this.$d(this.formSelectDate[1]).format('YYYY-MM-DD'),
                'pitcher': this.formSelectPlayer + '@' + this.formSelectTeam,
                'pitchingdata': {
                    'TaggedPitchType': this.formSelectBall
                },
                'limit': 1,
                he_first: true
            }
            if (this.formSelectType === 1) {
                query.level = 'Bullpen'
            }
            // console.log('getPitchesMulti', query
            API.PITCHES.getIndex(query,
                (json, status, headers) => {
                    this.getBallCountAll(headers.get('x-page-count'))
                },
                (error) => {
                    console.log('getBallCount取得失敗', error)
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getBallCount', JSON.stringify(error))
                }
            )
        },
        // 比較球検索（全球の球数）
        getBallCountAll (selectBallCount) {
            // 球数の取得
            let query = {
                'date-after': this.$d(this.formSelectDate[0]).format('YYYY-MM-DD'),
                'date-before': this.$d(this.formSelectDate[1]).format('YYYY-MM-DD'),
                'pitcher': this.formSelectPlayer + '@' + this.formSelectTeam,
                'limit': 1,
                he_first: true
            }
            if (this.formSelectType === 1) {
                query.level = 'Bullpen'
            }
            // console.log('getPitchesMulti', query)
            API.PITCHES.getIndex(query,
                (json, status, headers) => {
                    if (headers.get('x-page-count') > 3000) {
                        this.$root.$emit('messageModalOn', "抽出できる件数を超えました。<br>再度条件を変更してお試しください。")
                        return
                    }
                    if (headers.get('x-page-count') >= 300) {
                        if (selectBallCount > 0) {
                            this.loadingOn(selectBallCount + '球のデータを取得しています。<br>表示されるまで少々お待ち下さい。')
                        } else {
                            this.loadingOn(headers.get('x-page-count') + '球のデータを取得しています。<br>表示されるまで少々お待ち下さい。')
                        }
                    } else {
                        this.loadingOn()
                    }
                    this.formSubmitCompareBall()
                },
                (error) => {
                    console.log('getBallCount取得失敗', error)
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getBallCountAll', JSON.stringify(error))
                }
            )
        },
        formSubmitCompareBall () {
            let query = {
                'date-after': this.$d(this.formSelectDate[0]).format('YYYY-MM-DD'),
                'date-before': this.$d(this.formSelectDate[1]).format('YYYY-MM-DD'),
                'pitcher': this.formSelectPlayer + '@' + this.formSelectTeam,
                'limit': 5000,
                he_first: true
            }
            if (this.formSelectType === 1) {
                query.level = 'Bullpen'
            }
            if (this.searchModalType === 'standard') {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 検索', JSON.stringify(query))
            } else {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 検索', JSON.stringify(query))
            }
            API.PITCHES.getIndex(query,
                (json) => {
                    if (json.length === 0) {
                        this.loadingOff()
                        this.messageModalOn('指定した試合期間の投球データがありません。')
                    } else {
                        // this.mostFastBall = this.Caluate.getMostFastBall(json)
                        this.$on('formatComparePitchingData', this.formatComparePitchingData)
                        let tmpData = json.filter((d) => d.pitchingdata !== null).map((d,i)=>{
                            if (d.pitchingdata) {
                                if (d.pitchingdata.TaggedPitchType === 'FourSeamFastball') {
                                    d.pitchingdata.TaggedPitchType = 'Fastball'
                                }
                                if (d.pitchingdata.TaggedPitchType === 'OneSeamFastball') {
                                    d.pitchingdata.TaggedPitchType = 'TwoSeamFastball'
                                }
                                if (['FoulBallNotFieldable','FoulBallFieldable'].includes(d.pitchingdata.PitchCall)) {
                                    d.pitchingdata.PitchCall = 'FoulBall'
                                }
                            }
                            d.pitchofpa = Number(d.pitchofpa)
                            return d
                        })
                        Calculate.getMostFastBall(tmpData, 'formatComparePitchingData', this)
                        // this.formatComparePitchingData(json)
                        // this.ballsOfCompare = json
                        // this.searchState = 1
                    }
                },
                (error) => {
                    // console.log(json, this)
                    this.loadingOff()
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'formSubmitCompareBall', JSON.stringify(error))
                }
            )
        },
        formatComparePitchingData (balls) {
            // console.log('formatComparePitchingData', balls)
            let compareBalls = []
            this.mostFastBall = balls.mostFastBall
            this.savedBasllsId = this.currentSavedBallsId
            this.savedStandardBasllsId = this.currentSavedStandardBallId
            balls.defaultBalls.forEach((d) => {
                if (this.formSelectStadium !== '' && this.formSelectStadium !== d.pitchingdata['Stadium']) {
                    return
                }
                let tmpData = {}
                tmpData.id = ''
                tmpData.original = d
                tmpData.data = {}
                tmpData.data['Date'] = d.pitchingdata['Date']
                tmpData.data['pitchno'] = Number(d['pitchno'])
                tmpData.data['HitType'] = {
                    id: d.pitchingdata['HitType'],
                    name: setting.typesOfHitType.hasOwnProperty(d.pitchingdata['HitType']) ? setting.typesOfHitType[d.pitchingdata['HitType']].name : '―'
                }
                if (this.formSelectType === 0) {
                    tmpData.data['BatterTeamId'] = d['Batter']['team_id']
                    tmpData.data['BatterTeamName'] = this.listOfTeamsLS[d['Batter']['team_id']].name_short2
                    tmpData.data['BatterId'] = d['Batter']['identifier']
                    tmpData.data['BatterName'] = d['Batter']['name']
                } else {
                    tmpData.data['BatterTeamId'] = ''
                    tmpData.data['BatterTeamName'] = '-'
                    tmpData.data['BatterId'] = ''
                    tmpData.data['BatterName'] = '-'
                }
                tmpData.data.result = {
                    id: '',
                    name: '―'
                }
                // 判定結果振り分け インプレイ
                if (d.pitchingdata['PitchCall'] === 'InPlay') {
                    tmpData.data.result = {
                        id: d.pitchingdata['PlayResult'],
                        name: setting.typesOfPlayResult[d.pitchingdata['PlayResult']].name
                    }
                    // 判定結果振り分け インプレイ以外の三振、四球
                } else if (d.pitchingdata['KorBB'] !== 'Undefined') {
                    let KorBBID = ''
                    let KorBBName = '-'
                    if (d.pitchingdata['KorBB'] === 'Strikeout') {
                        if (d.pitchingdata['PitchCall'] === 'StrikeSwinging') {
                            KorBBID = 'StrikeoutSwinging'
                            KorBBName = '三振（空振り）'
                        } else if (d.pitchingdata['PitchCall'] === 'StrikeCalled') {
                            KorBBID = 'StrikeoutCalled'
                            KorBBName = '三振（見逃し）'
                        }
                    } else {
                        KorBBID = d.pitchingdata['KorBB']
                        KorBBName = this.typesOf3DSearchKorBB[d.pitchingdata['KorBB']].name
                    }
                    tmpData.data.result = {
                        id: KorBBID,
                        name: KorBBName
                    }
                    // 判定結果振り分け インプレイ以外の空振りストライク、見逃しストライク、ファール、ボール、デッドボール
                } else if (d.pitchingdata['PitchCall'] !== 'Undefined') {
                    let pitchCallID = ''
                    let pitchCallName = '-'
                    if (d.pitchingdata['PitchCall'] === 'StrikeSwinging') {
                        if (d.pitchingdata['Zone'] === 'Zone') {
                            pitchCallID = 'StrikeSwingingZone'
                            pitchCallName = '空振ストライク（ゾーン内）'
                        } else {
                            pitchCallID = 'StrikeSwingingO-Zone'
                            pitchCallName = '空振ストライク（ゾーン外）'
                        }
                    } else if (d.pitchingdata['PitchCall'] === 'HitByPitch') {
                        pitchCallID = 'BallCalledHitByPitch'
                        pitchCallName = 'デッドボール'
                    } else {
                        pitchCallID = d.pitchingdata['PitchCall']
                        // 登録されていないもの（BallIntentional）などはそのまま表示する
                        if (this.typesOf3DSearchPitchCall[d.pitchingdata['PitchCall']] === undefined) {
                            pitchCallName = d.pitchingdata['PitchCall']
                        } else {
                            pitchCallName = this.typesOf3DSearchPitchCall[d.pitchingdata['PitchCall']].name
                        }
                    }
                    tmpData.data.result = {
                        id: pitchCallID,
                        name: pitchCallName
                    }
                }
                tmpData.data['checkPitchCall'] = d.pitchingdata['PitchCall']
                tmpData.data['checkZone'] = d.pitchingdata['Zone']
                tmpData.data['TaggedPitchType'] = setting.typesOfBall[d.pitchingdata.TaggedPitchType].name
                tmpData.data['AlphaTaggedPitchType'] = d.pitchingdata.TaggedPitchType
                tmpData.data['RelSpeed'] = Math.round(d.pitchingdata['RelSpeed'] / 1000)
                tmpData.data['RelSpeed_Per'] = Math.round(((d.pitchingdata['RelSpeed'] / 1000) * 100) / balls.mostFastBall.ave_speed)
                if (d.pitchingdata['SpinRate'] !== null) {
                    tmpData.data['SpinRate'] = (Math.round(d.pitchingdata['SpinRate']))
                } else {
                    tmpData.data['SpinRate'] = '―'
                }
                if (d.pitchingdata['Rifle'] !== null) {
                    tmpData.data['Rifle'] = Math.round(d.pitchingdata['Rifle'])
                } else {
                    tmpData.data['Rifle'] = '―'
                }
                if (d.pitchingdata['w_sin_a'] !== null) {
                    tmpData.data['w_sin_a'] = Math.round(d.pitchingdata['w_sin_a'])
                } else {
                    tmpData.data['w_sin_a'] = '―'
                }
                tmpData.data['InducedVertBreak'] = Math.round(d.pitchingdata['InducedVertBreak'] * 100)
                tmpData.data['HorzBreak'] = Math.round(d.pitchingdata['HorzBreak'] * 100)
                tmpData.data['DeflectionAngle'] = Math.round(d.pitchingdata['DeflectionAngle'])
                tmpData.data['Depth'] = Math.round(d.pitchingdata['Depth'] * 100)
                tmpData.data['RelHeight'] = Math.round(d.pitchingdata['RelHeight'] * 100)
                tmpData.data['RelSide'] = Math.round(d.pitchingdata['RelSide'] * 100)
                tmpData.data['Extension'] = Math.round(d.pitchingdata['Extension'] * 100)
                if (d.pitchingdata['PA'] !== undefined) {
                    tmpData.data['AtBat'] = d.pitchingdata['PA']
                } else {
                    tmpData.data['AtBat'] = '-'
                }
                tmpData.id = d['id']
                compareBalls.push(tmpData)
            })
            this.loadingOff()
            this.defaultBalls = compareBalls
            this.allBallNumber = compareBalls.length
            this.ballsOfCompare = compareBalls
            this.searchState = 1
        },
        // 比較球に追加、削除
        addCompareBall (addBall) {
            let ball = {
                id: addBall.original.id,
                gameId: addBall.original.game_id,
                inning: addBall.original.inning,
                paofinning: addBall.original.paofinning,
                pitchofpa: addBall.original.pitchofpa,
                pitcher: {
                    id: addBall.original.Pitcher.identifier,
                    uniform_number: addBall.original.Pitcher.additional.uniform_number,
                    name: addBall.original.Pitcher.name
                },
                team: {
                    id: addBall.original.Pitcher.team_id,
                    name: this.listOfTeamsLS[addBall.original.Pitcher.team_id].name_short2
                },
                batter: {
                    id: addBall.original.Batter.identifier,
                    uniform_number: addBall.original.Batter.additional?.uniform_number ?? '999',
                    name: addBall.original.Batter.name
                },
                vsTeam: {
                    id: addBall.original.Batter.team_id,
                    name: this.listOfTeamsLS[addBall.original.Batter.team_id].name_short2
                },
                data: addBall.original,
                ballColor: '#ffffff',
                enabled: true,
                ballType: 'compare'
            }
            let duplicate = false
            let data = ball
            let savedBalls = this.$ls.get('savedBalls',[])
            if (savedBalls.length >= 20) {
                this.messageModalOn('比較球が20球登録されています。')
                return
            }
            let duplicateIndex = -1
            savedBalls.forEach(function (d, i) {
                if (d.data.id === data.data.id) {
                    duplicate = true
                    duplicateIndex = i
                }
            })
            if (duplicate) {
                savedBalls.splice(duplicateIndex, 1)
                this.$ls.set('savedBalls', savedBalls)
                this.getSavedBalls()
                this.$alert('投球を比較リストから削除しました。')
                this.savedBasllsId.splice(duplicateIndex, 1)
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 削除', ball.id, addBall.original.Pitcher['name'])
            } else {
                data = savedBalls.concat(data)
                this.$ls.set('savedBalls', data)
                this.getSavedBalls()
                this.$alert('投球を比較リストに追加しました。')
                this.savedBasllsId.push(ball.id)
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 追加', ball.id, addBall.original.Pitcher['name'])
            }
        },
        // 基準球に設定、解除
        addStandardBall (addBall) {
            let ball = {
                id: addBall.original['id'],
                gameId: addBall.original['game_id'],
                inning: addBall.original['inning'],
                paofinning: addBall.original['paofinning'],
                pitchofpa: addBall.original['pitchofpa'],
                pitcher: {
                    id: addBall.original.Pitcher['identifier'],
                    uniform_number: addBall.original.Pitcher.additional?.uniform_number ?? '999',
                    name: addBall.original.Pitcher['name']
                },
                team: {
                    id: addBall.original.Pitcher['team_id'],
                    name: this.listOfTeamsLS[addBall.original.Pitcher['team_id']].name_short2
                },
                batter: {
                    id: addBall.original.Batter['identifier'],
                    uniform_number: addBall.original.Batter.additional?.uniform_number ?? '999',
                    name: addBall.original.Batter['name']
                },
                vsTeam: {
                    id: addBall.original.Batter['team_id'],
                    name: this.listOfTeamsLS[addBall.original.Batter['team_id']].name_short2
                },
                data: addBall.original,
                ballColor: '#ff0000',
                enabled: true,
                ballType: 'standard'
            }
            let duplicate = false
            let data = ball
            let savedBalls = this.$ls.get('savedStandardBalls')
            savedBalls.forEach(function (d, i) {
                if (d.data.id === data.data.id) {
                    duplicate = true
                }
            })
            if (duplicate) {
                savedBalls = []
                this.$ls.set('savedStandardBalls', savedBalls)
                this.getSavedStandardBalls()
                this.$alert('基準球を解除しました。')
                this.savedStandardBasllsId = []
                common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 解除', ball.id, ball.pitcher.name)
            } else {
                data = [].concat(data)
                this.$ls.set('savedStandardBalls', data)
                this.getSavedStandardBalls()
                this.$alert('基準球を設定しました。')
                this.savedStandardBasllsId = []
                this.savedStandardBasllsId.push(ball.id)
                common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 設定', ball.id, ball.pitcher.name)
            }
        },
        getSavedBalls () {
            this.$emit('get-saved-balls')
        },
        getSavedStandardBalls () {
            this.$emit('get-saved-standard-balls')
        },
        completeAndUpdate () {
            this.$emit('close-search-modal')

            // フィルター条件をリセット
            this.filterSelectDate = ''
            this.formSelectBall = ''
            this.filterSelectHittype = ''
            this.filterSelectResult = ''
            this.filterSelectVsTeam = ''
            this.filterSelectVsBatter = ''
            this.filterSelectAtBat = ''
            this.searchState = 0

            window.setTimeout(() => {
                this.$emit('update-all')
            }, 200)
        },
        checkSelectPlayer () {
            this.isValidateList.player = this.formSelectPlayer !== ''
            this.checkValidate()
        },
        checkSelectDate () {
            this.isValidateList.date = this.formSelectDate[0] !== '' && this.formSelectDate[1] !== ''
            this.checkValidate()
        },
        checkValidate () {
            let valid = true
            let count = 0
            Object.keys(this.isValidateList).forEach((d) => {
                if (!this.isValidateList[d]) {
                    count++
                }
            })
            if (count === 0) {
                valid = false
            }
            this.isValidate = valid
        },
        changedYear (year) {
            if (year && this.formSelectTeam && this.formSelectPlayer) {
                this.getGameList()
            }
        }
    }
}
</script>
